import { createContext } from 'react';

interface Context {
  id: string;
  value: string;
  onChange: (value: string) => void;
}

export default createContext<Context>(null);
